module.exports = __webpack_public_path__ + "img/logo2.5ea65b9c.png";